import {Form, breakpoints, spacing} from '@webscale-oy/vaalikone-common-ui-base'
import styled from 'styled-components'

export const ResponsiveForm = styled(Form)`
  @media only screen and (max-width: ${breakpoints.tablet}) {
    width: 100%;
    padding: 0 ${spacing.space_4}px;
  }
`
